import { take, put, call, fork, select, race } from 'redux-saga/effects';
import moment from 'moment';
import _keyBy from 'lodash/keyBy';

import * as api from '../services/api';
import * as entitiesActions from '../actions/entities';
import * as environmentActions from '../actions/environment';
import { delay } from '../util';
import { getAuthedUser } from '../selectors';
import { handleError, checkForErrors, finishLoading } from './common';

import {
    RECEIVED_ENTITIES,
    RESTART_POLL,
    DATE_TIME_FORMAT,
} from '../constants';
import { GENERIC } from '../constants/loading';

const initialTodayTime = moment().startOf(`day`).format(DATE_TIME_FORMAT);

function* fetchEntities() {
    if (process.env.FAKE_API)
        yield call(delay, 2 * 1000);

    const user = yield select(getAuthedUser);

    // Run the api calls in parallel
    const responses = yield [
        call(api.fetchPlant),
        call(api.fetchPlantTypes),
        call(api.fetchPersons),
        call(api.fetchLocations),
        call(api.fetchTravelReasons, {
            query: {
                isDeleted: false,
            }
        }),
        call(api.fetchCostCentres),
        call(api.fetchBookings, {
            query: {
                maxStartTime: moment().startOf(`day`).add(3, `w`).format(DATE_TIME_FORMAT),
                minEndTime: initialTodayTime,
                personIds: [user.personId],
            }
        }),
    ];

    const priorityError = checkForErrors(responses);

    if (priorityError) {
        yield call(handleError, priorityError);
        console.log(`Error fetching entities: `, priorityError);
    } else if (responses) {
        yield put(entitiesActions.receivedEntities({
            plant: _keyBy(responses[0].body, `id`),
            plantTypes: _keyBy(responses[1].body, `id`),
            persons: _keyBy(responses[2].body, `id`),
            locations: _keyBy(responses[3].body, `id`),
            travelReasons: _keyBy(responses[4].body, `id`),
            costCentres: _keyBy(responses[5].body, `id`),
            bookings: _keyBy(responses[6].body, `staticUId`),
        }));
    }
}

function* pollEntities() {
    yield call(fetchEntities);
    yield call(delay, 60 * 1000);
}

function* forcePollEntities() {
    yield put(environmentActions.setLoadingUpdated(`Fetching latest data...`, GENERIC));
    yield put(entitiesActions.restartPoll());
    // TODO: The app will hang here if the api request is unsuccessful
    yield take(RECEIVED_ENTITIES);
    yield call(finishLoading, `Updated successfully.`);
}

function* watchPollEntities() {
    while (true) {
        yield race([
            call(pollEntities),
            take(RESTART_POLL),
        ]);
    }
}

export {
    fetchEntities,
    watchPollEntities,
    forcePollEntities,
};



// WEBPACK FOOTER //
// ./scripts/sagas/entities.js